// extracted by mini-css-extract-plugin
export default {"search":"index_search_le6Kg","searchInput":"index_searchInput_Ov4ak","searchBtn":"index_searchBtn_k4XBm"};